import {ListFieldButton, RemoveImages, Reports} from './Toolbar'

export const MobileContent = () => {
  return (
    <div className='gis-mobile-drawer__content'>
      <div className='gis-mobile-section'>
        <div className='gis-mobile-section__title'>Accesos</div>
        <div className='gis-mobile-action-grid'>
          <RemoveImages className='w-100' showDivider={false} />
          <ListFieldButton className='gis-mobile-action-card' />
          <Reports className='gis-mobile-action-card' />
        </div>
      </div>
    </div>
  )
}
